(function () {
  "use strict";

  function initProduct(root) {
    var variantData = root.querySelector("[data-variant-json]");
    if (!variantData) return;

    var variants;
    try {
      variants = JSON.parse(variantData.textContent || "[]");
    } catch (error) {
      return;
    }

    var optionGroups = Array.prototype.slice.call(root.querySelectorAll("[data-option-group]"));
    var optionButtons = Array.prototype.slice.call(root.querySelectorAll("[data-option-button]"));
    var variantInput = root.querySelector("[data-variant-input]");
    var price = root.querySelector("[data-product-price]");
    var comparePrice = root.querySelector("[data-compare-price]");
    var addToCart = root.querySelector("[data-add-to-cart]");
    var addToCartText = root.querySelector("[data-add-to-cart-text]");
    var selectionSummary = root.querySelector("[data-selection-summary]");
    var status = root.querySelector("[data-form-status]");
    var mainImage = root.querySelector("[data-main-image]");
    var thumbnails = Array.prototype.slice.call(root.querySelectorAll("[data-gallery-thumb]"));
    var form = root.querySelector("form.impdp__form");
    var productUrl = root.getAttribute("data-product-url") || window.location.pathname;

    function selectedValues() {
      return optionGroups.map(function (group) {
        var selected = group.querySelector('[data-option-button][aria-checked="true"]');
        return selected ? selected.getAttribute("data-option-value") : null;
      });
    }

    function variantMatches(variant, selected) {
      return selected.every(function (value, index) {
        return value === null || String(variant.options[index]) === String(value);
      });
    }

    function exactVariant(selected) {
      return variants.find(function (variant) {
        return variantMatches(variant, selected);
      }) || null;
    }

    function availableVariant(selected) {
      return variants.find(function (variant) {
        return variant.available && variantMatches(variant, selected);
      }) || null;
    }

    function activateImageById(imageId) {
      if (!mainImage || !imageId) return false;
      var thumb = thumbnails.find(function (candidate) {
        return String(candidate.getAttribute("data-image-id")) === String(imageId);
      });
      if (!thumb) return false;
      activateThumbnail(thumb);
      return true;
    }

    function activateImageByColor(color) {
      if (!color) return false;
      var normalized = String(color).toLowerCase();
      var thumb = thumbnails.find(function (candidate) {
        return String(candidate.getAttribute("data-image-alt") || "").toLowerCase().indexOf(normalized) !== -1;
      });
      if (!thumb) return false;
      activateThumbnail(thumb);
      return true;
    }

    function activateThumbnail(thumb) {
      if (!mainImage || !thumb) return;
      var src = thumb.getAttribute("data-image-src");
      var srcset = thumb.getAttribute("data-image-srcset");
      var alt = thumb.getAttribute("data-image-alt");
      var id = thumb.getAttribute("data-image-id");
      if (src) mainImage.src = src;
      if (srcset) mainImage.srcset = srcset;
      if (alt) mainImage.alt = alt;
      if (id) mainImage.setAttribute("data-image-id", id);
      thumbnails.forEach(function (candidate) {
        var active = candidate === thumb;
        candidate.classList.toggle("is-active", active);
        candidate.setAttribute("aria-pressed", active ? "true" : "false");
      });
    }

    function updateAvailability(selected) {
      optionButtons.forEach(function (button) {
        var optionIndex = Number(button.getAttribute("data-option-index"));
        var candidateSelection = selected.slice();
        candidateSelection[optionIndex] = button.getAttribute("data-option-value");
        var possible = Boolean(availableVariant(candidateSelection));
        button.disabled = !possible;
        button.setAttribute("aria-disabled", possible ? "false" : "true");
      });
    }

    function updateSizePrices(selected) {
      optionButtons.forEach(function (button) {
        var priceLabel = button.querySelector("[data-option-price]");
        if (!priceLabel) return;
        var optionIndex = Number(button.getAttribute("data-option-index"));
        var candidateSelection = selected.slice();
        candidateSelection[optionIndex] = button.getAttribute("data-option-value");
        var candidate = availableVariant(candidateSelection) || exactVariant(candidateSelection);
        priceLabel.textContent = candidate ? candidate.priceFormatted : "";
      });
    }

    function updateUrl(variant) {
      if (!variant || !window.history || !window.history.replaceState) return;
      try {
        var url = new URL(productUrl, window.location.origin);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({ variantId: variant.id }, "", url.pathname + url.search + window.location.hash);
      } catch (error) {}
    }

    function updateVariant() {
      var selected = selectedValues();
      var variant = exactVariant(selected);

      updateAvailability(selected);
      updateSizePrices(selected);

      optionGroups.forEach(function (group, index) {
        var label = group.querySelector("[data-selected-option-label]");
        if (label) label.textContent = selected[index] || "";
      });

      if (!variant) {
        if (variantInput) variantInput.value = "";
        if (addToCart) addToCart.disabled = true;
        if (addToCartText) addToCartText.textContent = "Choose an available combination";
        if (selectionSummary) selectionSummary.textContent = selected.filter(Boolean).join(" / ");
        if (status) status.textContent = "That option combination is not currently available.";
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = variant.priceFormatted;

      if (comparePrice) {
        if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
          comparePrice.textContent = variant.compareAtFormatted;
          comparePrice.classList.remove("is-hidden");
        } else {
          comparePrice.textContent = "";
          comparePrice.classList.add("is-hidden");
        }
      }

      if (selectionSummary) selectionSummary.textContent = variant.title;
      if (addToCart) addToCart.disabled = !variant.available;
      if (addToCartText) addToCartText.textContent = variant.available ? "Add to cart · " + variant.priceFormatted : "Unavailable";
      if (status) status.textContent = variant.available ? "" : "This combination is not currently available.";

      if (!activateImageById(variant.imageId)) {
        var colorGroup = optionGroups.find(function (group) {
          var selectedButton = group.querySelector('[data-option-button][aria-checked="true"]');
          return selectedButton && String(selectedButton.getAttribute("data-option-name") || "").toLowerCase() === "color";
        });
        var colorButton = colorGroup && colorGroup.querySelector('[data-option-button][aria-checked="true"]');
        if (colorButton) activateImageByColor(colorButton.getAttribute("data-option-value"));
      }

      updateUrl(variant);
    }

    optionButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        if (button.disabled) return;
        var optionIndex = button.getAttribute("data-option-index");
        optionButtons.forEach(function (candidate) {
          if (candidate.getAttribute("data-option-index") !== optionIndex) return;
          var selected = candidate === button;
          candidate.classList.toggle("is-selected", selected);
          candidate.setAttribute("aria-checked", selected ? "true" : "false");
        });
        updateVariant();
      });
    });

    thumbnails.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        activateThumbnail(thumb);
      });
    });

    var quantityInput = root.querySelector("[data-quantity-input]");
    var quantityMinus = root.querySelector("[data-quantity-minus]");
    var quantityPlus = root.querySelector("[data-quantity-plus]");

    function normalizedQuantity() {
      var value = quantityInput ? parseInt(quantityInput.value, 10) : 1;
      return Number.isFinite(value) && value > 0 ? value : 1;
    }

    if (quantityMinus && quantityInput) {
      quantityMinus.addEventListener("click", function () {
        quantityInput.value = Math.max(1, normalizedQuantity() - 1);
      });
    }
    if (quantityPlus && quantityInput) {
      quantityPlus.addEventListener("click", function () {
        quantityInput.value = normalizedQuantity() + 1;
      });
    }
    if (quantityInput) {
      quantityInput.addEventListener("change", function () {
        quantityInput.value = normalizedQuantity();
      });
    }

    var fitDialog = root.querySelector("[data-fit-dialog]");
    Array.prototype.slice.call(root.querySelectorAll("[data-open-fit-help]")).forEach(function (button) {
      button.addEventListener("click", function () {
        if (!fitDialog) return;
        if (typeof fitDialog.showModal === "function") fitDialog.showModal();
        else fitDialog.setAttribute("open", "open");
      });
    });

    if (form) {
      form.addEventListener("submit", function (event) {
        var selected = selectedValues();
        var variant = exactVariant(selected);
        if (!variant || !variant.available) {
          event.preventDefault();
          if (status) status.textContent = "Choose an available color and size before adding to cart.";
        }
      });
    }

    updateVariant();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll("[data-impdp]")).forEach(initProduct);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
